// The after-dinner talk is typed (iOS dictation into a textarea, Meal Hat's
// talk-through pattern), and a long ramble means tapping the mic more than
// once — so the draft is saved on every keystroke. Losing four minutes of
// three people's opinions to a backgrounded tab would end the feature.
const key = (lessonId) => `enjoyCookingDebriefDraft:${lessonId}`;

export function readDraft (lessonId) {
  try { return localStorage.getItem(key(lessonId)) || ''; } catch { return ''; }
}

export function writeDraft (lessonId, text) {
  try {
    if (text) localStorage.setItem(key(lessonId), text);
    else localStorage.removeItem(key(lessonId));
  } catch { /* storage full or blocked */ }
}

export const clearDraft = (lessonId) => writeDraft(lessonId, '');
